import React from 'react';
import './Spinner.scss'; 

const Spinner = ({ variant, size }) => {
  return (
    <div className={`spinner ${variant === 'dark' ? 'dark' : ''} ${size === 'big' ? 'big' : ''}`}></div>
  );
};

export default Spinner;